import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-66f4e1a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["src", "alt"]
const _hoisted_2 = { class: "flex flex-column w-full justify-content-center text-center sm:text-left overflow-hidden" }
const _hoisted_3 = { class: "m-0 overflow-hidden text-overflow-ellipsis white-space-nowrap" }
const _hoisted_4 = ["href"]
const _hoisted_5 = { class: "created-at text-xs my-1" }
const _hoisted_6 = {
  key: 0,
  class: "description text-sm my-1"
}
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "flex flex-column mt-1 justify-content-center sm:align-items-center sm:flex-row sm:justify-content-start text-sm" }
const _hoisted_9 = { class: "flex align-items-center justify-content-center" }
const _hoisted_10 = { class: "pr-2 border-right-1" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "pi pi-comments" }, null, -1))
const _hoisted_12 = { class: "mt-2 sm:mt-0" }

import TagWrapper from "@/components/tag/TagWrapper.vue";
import BookmarkButton from "@/components/bookmark/BookmarkButton.vue";
import PostOptionButton from "@/components/post/PostOptionButton.vue";
import UserLink from "@/components/UserLink.vue";
import { nlToBr } from "@/filters/nlToBrFilter";
import { useAuth0 } from "@auth0/auth0-vue";
import { useRouter } from "vue-router";
import { Post } from "@/models/post";


export default /*#__PURE__*/_defineComponent({
  props: {
    post: null
  },
  emits: ["delete-click"],
  setup(__props: any, { emit }) {

const props = __props as {
  post: Post
}



const router = useRouter();

const { user } = useAuth0();



const domainName = new URL(props.post.url).hostname;
const openArticle = (id: string) => {
  router.push(`/post/${id}`);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "flex flex-column sm:flex-row align-items-center col-12 py-2 px-3 sm:p-3 hover:surface-100 cursor-hover",
    onClick: _cache[2] || (_cache[2] = ($event: any) => (openArticle(__props.post.uuid)))
  }, [
    _createElementVNode("img", {
      class: "mb-2 sm:mb-0 sm:mr-3",
      src: `https://www.google.com/s2/favicons?sz=256&domain_url=${_unref(domainName)}`,
      alt: _unref(domainName)
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("p", _hoisted_3, [
        _createElementVNode("a", {
          href: __props.post.url,
          target: "_blank",
          rel: "noopener noreferrer",
          onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"])),
          class: "no-underline"
        }, _toDisplayString(__props.post.title ? __props.post.title : __props.post.url), 9, _hoisted_4)
      ]),
      _createElementVNode("span", _hoisted_5, [
        _createVNode(UserLink, {
          username: __props.post.user.username,
          id: __props.post.user.id,
          class: "font-semibold"
        }, null, 8, ["username", "id"]),
        _createTextVNode(" posted on " + _toDisplayString(new Date(__props.post.created_at.replace(" ", "T")).toLocaleDateString()), 1)
      ]),
      (__props.post.description && __props.post.description.length !== 0)
        ? (_openBlock(), _createElementBlock("p", _hoisted_6, [
            _createElementVNode("span", {
              innerHTML: _unref(nlToBr)(__props.post.description).value
            }, null, 8, _hoisted_7)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("span", _hoisted_10, [
            _hoisted_11,
            _createTextVNode(" " + _toDisplayString(__props.post.comments_aggregate.aggregate.count), 1)
          ]),
          _createVNode(BookmarkButton, {
            class: "ml-2 mr-2",
            bookmarked: __props.post.bookmarks.length !== 0,
            uuid: __props.post.uuid
          }, null, 8, ["bookmarked", "uuid"])
        ]),
        _createElementVNode("span", _hoisted_12, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.post.post_tags, (tags) => {
            return (_openBlock(), _createBlock(TagWrapper, {
              class: "mr-1 mt-1 sm:mt-0",
              key: tags.uuid,
              value: tags.tag.name
            }, null, 8, ["value"]))
          }), 128))
        ])
      ])
    ]),
    (__props.post.user.id === _unref(user).sub)
      ? (_openBlock(), _createBlock(PostOptionButton, {
          key: 0,
          postId: __props.post.uuid,
          onDeleteClick: _cache[1] || (_cache[1] = ($event: any) => (emit('delete-click', __props.post.uuid)))
        }, null, 8, ["postId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})